import React from "react";
import {
  Box,
  Typography,
  Grid,
  Avatar,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import LockIcon from "@mui/icons-material/Lock";
import PersonIcon from "@mui/icons-material/Person";
import img from "./img/whatsPaymentImg2.webp"; // Ensure this path is correct

const UsePayment = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        background: "linear-gradient(135deg, #c5e3f5 0%, #ddeffa 100%)",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          py: { xs: 5, md: 10 },
          px: { xs: 2, md: 8 },
          width: { xl: "74%", lg: "79%", md: "90%", sm: "90%" },
        }}
      >
        <Grid container spacing={6} alignItems="center">
          {/* Left Section: Text Content */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{ pr: { md: 5 }, textAlign: { xs: "center", md: "left" } }}
            >
              <Typography
                variant="h3"
                fontWeight="bold"
                sx={{
                  fontSize: { xs: "2rem", md: "3.2rem" },
                }}
                gutterBottom
              >
                Why Use <span style={{ color: "#00E676" }}>WhatsApp</span>{" "}
                Payments?
              </Typography>

              {/* Image shown after title on small devices */}
              <Box
                sx={{
                  display: { xs: "block", md: "none" },
                  marginBottom: { xs: "24px" },
                  marginTop: { xs: "24px" },
                }}
              >
                <img
                  src={img}
                  alt="WhatsApp Payment Illustration"
                  style={{ width: "100%", maxWidth: 520, height: "auto" }}
                />
              </Box>

              <Typography
                variant="body1"
                color="text.secondary"
                sx={{ mb: 4, fontSize: { xs: "1rem", md: "1.1rem" } }}
              >
                Whether you're running an e-Commerce business or providing
                services, WhatsApp Payments offers a secure, easy-to-use
                solution that fits perfectly into the customer journey.
              </Typography>

              {/* Feature 1 */}
              <Box display="flex" textAlign={'left'} alignItems="flex-start" mb={3}>
                <Avatar
                  sx={{ bgcolor: "#f5f5f5", color: "rgb(5, 78, 146)", mr: 2 }}
                >
                  <ShoppingCartCheckoutIcon />
                </Avatar>
                <Box>
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    sx={{ fontSize: { xs: "1.1rem", md: "1.25rem" } }}
                  >
                    Convenience
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ fontSize: { xs: "0.95rem", md: "1.05rem" } }}
                  >
                    Customers can complete transactions within their chat
                    window, eliminating the need to switch platforms.
                  </Typography>
                </Box>
              </Box>

              {/* Feature 2 */}
              <Box display="flex" textAlign={'left'} alignItems="flex-start" mb={3}>
                <Avatar
                  sx={{ bgcolor: "#f5f5f5", color: "rgb(5, 78, 146)", mr: 2 }}
                >
                  <LockIcon />
                </Avatar>
                <Box>
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    sx={{ fontSize: { xs: "1.1rem", md: "1.25rem" } }}
                  >
                    Security
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ fontSize: { xs: "0.95rem", md: "1.05rem" } }}
                  >
                    Powered by WhatsApp’s encryption, ensuring every transaction
                    is safe.
                  </Typography>
                </Box>
              </Box>

              {/* Feature 3 */}
              <Box display="flex" textAlign={'left'} alignItems="flex-start">
                <Avatar
                  sx={{ bgcolor: "#f5f5f5", color: "rgb(5, 78, 146)", mr: 2 }}
                >
                  <PersonIcon />
                </Avatar>
                <Box>
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    sx={{ fontSize: { xs: "1.1rem", md: "1.25rem" } }}
                  >
                    Efficiency
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ fontSize: { xs: "0.95rem", md: "1.05rem" } }}
                  >
                    Reduce payment friction and boost conversion rates by
                    streamlining the payment process.
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>

          {/* Right Section: Image for medium and larger devices */}
          <Grid
            item
            xs={12}
            md={6}
            sx={{ display: { xs: "none", md: "flex" } }}
          >
            <Box sx={{ textAlign: "right", pl: { md: 5 } }}>
              <img
                src={img}
                alt="WhatsApp Payment Illustration"
                style={{ width: "100%", maxWidth: 520, height: "auto" }}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default UsePayment;
